export default __webpack_public_path__ + "static/media/NoelBlanc.d7105ebc.mp3";